import type { CalloutContent, CalloutVariant } from './schema.types';

export const CALLOUT_VARIANTS: CalloutVariant[] = [
  'important_concept',
  'common_mistake',
  'memory_trick',
];

export const CALLOUT_VARIANT_LABELS: Record<CalloutVariant, string> = {
  common_mistake: 'Common mistake',
  memory_trick: 'Memory trick',
  important_concept: 'Important concept',
};

export const CALLOUT_BODY_PLACEHOLDERS: Record<CalloutVariant, string> = {
  common_mistake: "What's a common mistake students make here?",
  memory_trick: 'Share a memory aid or mnemonic…',
  important_concept: 'Emphasise the key idea…',
};

/** Visual theme per variant. `icon` is a lucide id rendered by CalloutElement. */
export const CALLOUT_VARIANT_STYLE: Record<
  CalloutVariant,
  { bg: string; border: string; accent: string; icon: string; defaultTitle: string }
> = {
  common_mistake: {
    bg: '#fef2f2',
    border: '#fecaca',
    accent: '#dc2626',
    icon: 'AlertTriangle',
    defaultTitle: 'Common mistake',
  },
  memory_trick: {
    bg: '#fffbeb',
    border: '#fde68a',
    accent: '#d97706',
    icon: 'Lightbulb',
    defaultTitle: 'Memory trick',
  },
  important_concept: {
    bg: '#eff6ff',
    border: '#bfdbfe',
    accent: '#2563eb',
    icon: 'Star',
    defaultTitle: 'Important concept',
  },
};

export function defaultCalloutContent(variant: CalloutVariant = 'important_concept'): CalloutContent {
  return { variant, body: '' };
}
